module.exports = __webpack_public_path__ + "img/sam_eguavoen.ff9d9a74.png";